function NetworkVisual({ variant = 'hero' }) {
  if (variant === 'dashboard') {
    return (
      <div className="nv-dashboard">
        <div className="nv-dash-header">
          <div className="nv-dash-title">
            <span className="nv-dot green"></span> Netwatch — Network Overview
          </div>
          <div className="nv-dash-meta">
            <span className="nv-badge">Live</span>
            <span style={{ color: '#6b7280', fontSize: '12px' }}>Last updated: just now</span>
          </div>
        </div>

        <div className="nv-stats-row">
          {[
            { label: 'Devices Online', value: '—', icon: 'fa-server', color: '#0e63ff' },
            { label: 'DNS Queries/s', value: '—', icon: 'fa-globe', color: '#00d4ff' },
            { label: 'DHCP Leases', value: '—', icon: 'fa-network-wired', color: '#10b981' },
            { label: 'Active Alerts', value: '—', icon: 'fa-bell', color: '#f59e0b' },
          ].map((stat, i) => (
            <div key={i} className="nv-stat-card">
              <div className="nv-stat-icon" style={{ color: stat.color }}>
                <i className={`fas ${stat.icon}`}></i>
              </div>
              <div>
                <div className="nv-stat-value">{stat.value}</div>
                <div className="nv-stat-label">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="nv-chart-row">
          <div className="nv-chart-panel">
            <div className="nv-panel-title">Network Traffic</div>
            <div className="nv-bars">
              {[40, 65, 50, 80, 55, 90, 70, 60, 85, 72, 95, 78].map((h, i) => (
                <div key={i} className="nv-bar" style={{ height: `${h}%`, animationDelay: `${i * 0.05}s` }}></div>
              ))}
            </div>
          </div>
          <div className="nv-device-panel">
            <div className="nv-panel-title">Device Discovery</div>
            {[
              { name: 'Cisco Routers', count: '—', icon: 'fa-network-wired', ok: true },
              { name: 'Juniper Switches', count: '—', icon: 'fa-project-diagram', ok: true },
              { name: 'Fortinet FW', count: '—', icon: 'fa-shield-alt', ok: true },
              { name: 'DHCP Servers', count: '—', icon: 'fa-server', ok: false },
            ].map((d, i) => (
              <div key={i} className="nv-device-row">
                <i className={`fas ${d.icon} nv-device-icon`}></i>
                <span className="nv-device-name">{d.name}</span>
                <span className="nv-device-count">{d.count}</span>
                <span className={`nv-dot ${d.ok ? 'green' : 'amber'}`}></span>
              </div>
            ))}
          </div>
        </div>

        <div className="nv-coming-soon-bar">
          <i className="fas fa-rocket"></i> Full UI available at launch — July–August 2026
        </div>
      </div>
    );
  }

  return (
    <div className="nv-hero-visual">
      <div className="nv-topology">
        <svg viewBox="0 0 400 320" className="nv-svg">
          <defs>
            <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0e63ff" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#00d4ff" stopOpacity="0.6" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur" />
              <feMerge><feMergeNode in="coloredBlur" /><feMergeNode in="SourceGraphic" /></feMerge>
            </filter>
          </defs>

          {[
            [200, 60, 200, 155], [200, 155, 100, 230], [200, 155, 200, 230],
            [200, 155, 300, 230], [100, 230, 60, 290], [100, 230, 140, 290],
            [300, 230, 260, 290], [300, 230, 340, 290],
          ].map(([x1, y1, x2, y2], i) => (
            <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="url(#lineGrad)" strokeWidth="1.5" opacity="0.7" />
          ))}

          {[
            { cx: 200, cy: 55, r: 22, icon: '☁', label: 'Core', color: '#0e63ff', delay: '0s' },
            { cx: 200, cy: 155, r: 18, icon: '⚡', label: 'Router', color: '#00d4ff', delay: '0.3s' },
            { cx: 100, cy: 230, r: 15, icon: '⬡', label: 'Switch', color: '#0e63ff', delay: '0.6s' },
            { cx: 200, cy: 230, r: 15, icon: '⬡', label: 'Switch', color: '#0e63ff', delay: '0.8s' },
            { cx: 300, cy: 230, r: 15, icon: '⬡', label: 'Switch', color: '#0e63ff', delay: '1s' },
            { cx: 60, cy: 290, r: 10, icon: '▣', label: 'Device', color: '#10b981', delay: '1.2s' },
            { cx: 140, cy: 290, r: 10, icon: '▣', label: 'Device', color: '#10b981', delay: '1.4s' },
            { cx: 260, cy: 290, r: 10, icon: '▣', label: 'Device', color: '#10b981', delay: '1.6s' },
            { cx: 340, cy: 290, r: 10, icon: '▣', label: 'Device', color: '#10b981', delay: '1.8s' },
          ].map((node, i) => (
            <g key={i} filter="url(#glow)" className="nv-node" style={{ animationDelay: node.delay }}>
              <circle cx={node.cx} cy={node.cy} r={node.r} fill={node.color} fillOpacity="0.15" stroke={node.color} strokeWidth="1.5" />
              <circle cx={node.cx} cy={node.cy} r={node.r + 4} fill="none" stroke={node.color} strokeWidth="0.5" strokeOpacity="0.3" className="nv-pulse-ring" style={{ animationDelay: node.delay }} />
            </g>
          ))}

          {[
            { cx: 200, cy: 55, label: 'Cloud Core' },
            { cx: 200, cy: 155, label: 'Core Router' },
            { cx: 100, cy: 230, label: 'Distribution' },
            { cx: 300, cy: 230, label: 'Distribution' },
          ].map((t, i) => (
            <text key={i} x={t.cx} y={t.cy + 32} textAnchor="middle" fill="#94a3b8" fontSize="9" fontFamily="Poppins, sans-serif">{t.label}</text>
          ))}
        </svg>

        <div className="nv-status-pills">
          <span className="nv-pill green"><span className="nv-dot green"></span> Discovery Active</span>
          <span className="nv-pill blue"><span className="nv-dot blue"></span> Monitoring</span>
          <span className="nv-pill amber"><span className="nv-dot amber"></span> Preview at Launch</span>
        </div>
      </div>
    </div>
  );
}

export default NetworkVisual;
